var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };} /* eslint-disable react/no-multi-comp */
import React from 'react';
import { createColumnHelper } from '@tanstack/react-table';
import { ChevronDownIcon, ChevronUpIcon } from '@heroicons/react/24/outline';

import { useSetAtom } from 'jotai';
import { Translate } from "../../../../../I18N";
import { Button, EmbededButton } from "../../../../Components/UI";
import { sidepanelAtom } from "./sidepanelAtom";

const columnHelper = createColumnHelper();

const TitleHeader = () => /*#__PURE__*/_jsx(Translate, {}, void 0, "Label");
const ActionHeader = () => /*#__PURE__*/_jsx(Translate, {}, void 0, "Action");

const Filters = ({ row, getValue }) => /*#__PURE__*/
_jsx("div", { className: "flex gap-2 items-center" }, void 0, /*#__PURE__*/
_jsx(Translate, {
  context: "Filters",
  className: row.getIsExpanded() ? 'text-indigo-700' : 'text-indigo-700' }, void 0,

getValue()
),
row.getCanExpand() && /*#__PURE__*/
_jsx(EmbededButton, {
  icon: row.getIsExpanded() ? /*#__PURE__*/_jsx(ChevronUpIcon, {}) : /*#__PURE__*/_jsx(ChevronDownIcon, {}),
  onClick: () => row.toggleExpanded(),
  color: "indigo",
  className: "bg-indigo-200 rounded-md border-none drop-shadow-none" }, void 0, /*#__PURE__*/

_jsx(Translate, {}, void 0, "Group")
)

);


const ActionCell = ({ cell, row }) => {var _cell$column$columnDe;
  const action = (_cell$column$columnDe = cell.column.columnDef.meta) === null || _cell$column$columnDe === void 0 ? void 0 : _cell$column$columnDe.action;
  const setAtom = useSetAtom(sidepanelAtom);

  if (!cell.getIsAggregated()) {
    return undefined;
  }

  return /*#__PURE__*/(
    _jsx(Button, {
      styling: "outline",
      color: "primary",
      className: "leading-3",
      onClick: () => {
        if (action) {
          setAtom(row.original);
          action(true);
        }
      } }, void 0, /*#__PURE__*/

    _jsx(Translate, {}, void 0, "Edit")
    ));

};

const createColumns = (setSidepanel) => [
columnHelper.accessor('name', {
  id: 'name',
  header: TitleHeader,
  cell: Filters,
  meta: { headerClassName: 'w-full' }
}),
columnHelper.display({
  id: 'action',
  header: ActionHeader,
  cell: ActionCell,
  enableSorting: false,
  meta: {
    action: setSidepanel,
    headerClassName: 'w-0 sr-only'
  }
})];


export { createColumns };